import * as types from "../actions/ActionTypes";
// import _ from "lodash";

const defaultState = {
  isRequesting: false,
  isRequestingByUser: false,
  isRequestingByIds: false,
  contents: [],
  contentsByCategoryPending: false,
  contentsByCategory: {
    series: {},
    community: {},
  },
  contentsByUser: [],
  contentsByIds: [],
  seriesByIds: [],
  selectedItem: {},
  contentPosted: false,
  contentPosting: false,
  contentPostError: {},
  checkMediaPosting: false,
  checkMediaError: {},
  exists: {},
  currentContentLanding: null,
  currentSerieLanding: null,
  contentDeletePending: false,
  contentDeleteFulfilled: false,
  contentDeleteError: {},

  hash: "",
  video: [],
  uploadInformationContent: {},
  playingVideo: undefined,
  buyModalOpen: false,

  weblinkURL: "",

  progressByHttp: [],

  mainPlayerOpen: false,
  mainPlayer: {},
  mainPlayerVideoUuid: "",
  mainPlayerVideoHash: "",
  mainPlayerContentType: "",
  serieDraft: { videos: [] },
  serie: { videos: [] },
  filter: "series",

  topContentByCategory: {
    community: null,
    series: null,
  },
  contentByCategory: {
    community: [],
    series: [],
  },
  currentCarruselLanding: null,
  videoSubtitles: [],

  contentToUpload: {
    metadata: [],
    tags: [],
    rating: 1,
    audioLang: "es",
    authorFee: "1.00",
    seederFee: "50",
  },
  contentToUpload_subtitles: [],
  contentToUpload_cover: null,
  contentUploadUUID: "",
  drmToken: "",
  manifestURL: "",
  contentToUploadCurrentStep: "Video",
  isEditingContent: false,
  contentToEdit: {
    metadata: [],
    moderationMessage: "",
    categoryId: null,
    seederFee: null,
    authorFee: null,
    audioLang: "",
    releaseDate: "",
    finishDate: "",
    privacy: null,
    payType: null,
    bodyFormat: null,
    contentType: null,
    rating: null,
    credits: "",
    tags: [],
    newMediaIds: [],
    deleteMediaIds: [],
    newSubtitleIds: [],
    deleteSubtitleIds: []
  },
  contentToShow: [],
};

export default function reducer(state = defaultState, action) {
  state = { ...defaultState, ...state };

  switch (action.type) {
    case types.CONTENTS_PENDING:
      return Object.assign({}, state, {
        isRequesting: true,
      });
    case types.CONTENTS_FULFILLED:
      return Object.assign({}, state, {
        isRequesting: false,
        contents: action.payload,
      });
    case types.CONTENTS_REJECTED:
      return Object.assign({}, state, {
        isRequesting: false,
        contents: [],
      });

    case types.CONTENTS_BY_CATEGORY_PENDING:
      return Object.assign({}, state, {
        contentsByCategoryPending: true,
      });
    case types.CONTENTS_BY_CATEGORY_FULFILLED:
      if (action.payload.contents[0] !== undefined) {
        action.id = action.payload.contents[0].categoryId;
        let filter = state.filter;
        let newObj = {
          payload: action.payload,
          timestamp: new Date().getTime(),
        };
        let result;
        let oldContentsByCategory = state.contentsByCategory;

        filter === "community"
          ? (oldContentsByCategory.community[action.id] = newObj)
          : (oldContentsByCategory.series[action.id] = newObj);
        result = Object.assign({}, state, {
          contentsByCategoryPending: false,
          contentsByCategory: oldContentsByCategory,
        });
        return result;
      } else {
        state.contentsByCategoryPending = false;
        return state;
      }
    case types.CONTENTS_BY_CATEGORY_REJECTED:
      return Object.assign({}, state, {
        contentsByCategoryPending: false,
        contentsByCategory: [],
      });

    case types.CONTENTS_BY_USER_PENDING:
      return Object.assign({}, state, {
        isRequestingByUser: true,
      });
    case types.CONTENTS_BY_USER_FULFILLED:
      return Object.assign({}, state, {
        isRequestingByUser: false,
        contentsByUser: action.payload,
      });
    case types.CONTENTS_BY_USER_REJECTED:
      return Object.assign({}, state, {
        isRequestingByUser: false,
        contentsByUser: [],
      });

    case types.CONTENTS_BY_IDS_PENDING:
      return Object.assign({}, state, {
        isRequestingByIds: true,
      });
    case types.CONTENTS_BY_IDS_FULFILLED:
      return Object.assign({}, state, {
        isRequestingByIds: false,
        contentsByIds: action.payload,
      });
    case types.CONTENTS_BY_IDS_REJECTED:
      return Object.assign({}, state, {
        isRequestingByIds: false,
        contentsByIds: [],
      });

    case types.SERIES_BY_IDS_PENDING:
      return Object.assign({}, state, {
        isRequestingByIds: true,
      });
    case types.SERIES_BY_IDS_FULFILLED:
      return Object.assign({}, state, {
        isRequestingByIds: false,
        seriesByIds: action.payload,
      });
    case types.SERIES_BY_IDS_REJECTED:
      return Object.assign({}, state, {
        isRequestingByIds: false,
        seriesByIds: [],
      });

    case types.CONTENT_PENDING:
      return Object.assign({}, state, {
        isRequesting: true,
      });
    case types.CONTENT_FULFILLED:
      return Object.assign({}, state, {
        isRequesting: false,
        selectedItem: action.payload,
      });
    case types.CONTENT_REJECTED:
      return Object.assign({}, state, {
        isRequesting: false,
        selectedItem: {},
      });

    case types.CONTENT_POST_PENDING:
      return Object.assign({}, state, {
        contentPosting: true,
      });
    case types.CONTENT_POST_FULFILLED:
      return Object.assign({}, state, {
        contentPosting: false,
        contentPosted: true,
      });
    case types.CONTENT_POST_REJECTED:
      return Object.assign({}, state, {
        contentPosting: false,
        contentPostError: action.payload.response,
      });

    case types.CONTENT_DELETE_PENDING:
      return Object.assign({}, state, {
        contentDeletePending: true,
      });
    case types.CONTENT_DELETE_FULFILLED:
      return Object.assign({}, state, {
        contentDeletePending: false,
        contentDeleteFulfilled: true,
      });
    case types.CONTENT_DELETE_REJECTED:
      return Object.assign({}, state, {
        contentDeletePending: false,
        contentDeleteError: action.payload.response,
      });

    case types.CONTENT_HASH:
      return Object.assign({}, state, {
        hash: action.payload,
      });

    case types.CONTENT_HASH_RESET:
      return Object.assign({}, state, {
        hash: "",
      });

    case types.CONTENT_VIDEO:
      return Object.assign({}, state, {
        video: action.payload,
      });

    case types.CONTENT_VIDEO_RESET:
      return Object.assign({}, state, {
        video: "",
      });

    case types.CONTENT_RESET:
      return defaultState;

    case types.SELECTED_ITEM_RESET:
      return Object.assign({}, state, {
        selectedItem: {},
      });

    case types.CONTENT_UPLOAD_INFORMATION:
      return Object.assign({}, state, {
        uploadInformationContent: action.payload,
      });
    case types.CONTENT_PLAY:
      return Object.assign({}, state, {
        playingVideo: action.payload,
      });
    case types.CONTENT_PAUSE:
      return Object.assign({}, state, {
        playingVideo: undefined,
      });
    case types.CONTENT_OPEN_BUY_MODAL:
      return Object.assign({}, state, {
        buyModalOpen: true,
      });
    case types.CONTENT_CLOSE_BUY_MODAL:
      return Object.assign({}, state, {
        buyModalOpen: false,
      });
    // case types.CONTENT_PROGRESS_BY_HTTP:
      // let progressByHttp = _.cloneDeep(state.progressByHttp);
      // const index = progressByHttp.findIndex((p) => {
      //   return p.hash === action.payload.hash;
      // });

      // if (index !== -1) {
      //   progressByHttp[index].data = action.payload.data;
      // } else {
      //   progressByHttp.push(action.payload);
      // }

      // return Object.assign({}, state, {
      //   progressByHttp: progressByHttp,
      // });
    case types.TOGGLE_MAIN_PLAYER:
      return Object.assign({}, state, {
        mainPlayerOpen: !state.mainPlayerOpen,
      });
    case types.MAIN_PLAYER:
      return Object.assign({}, state, {
        mainPlayer: action.payload,
      });
    case types.MAIN_PLAYER_HASH:
      return Object.assign({}, state, {
        mainPlayerVideoHash: action.payload,
      });
    case types.MAIN_PLAYER_VIDEO_UUID:
      return Object.assign({}, state, {
        mainPlayerVideoUuid: action.payload,
      });

    case types.MAIN_PLAYER_CONTENTTYPE:
      return Object.assign({}, state, {
        mainPlayerContentType: action.payload,
      });

    case types.MAIN_PLAYER_VIDEO_SUB:
      return Object.assign({}, state, {
        mainPlayerVideoSub: action.payload,
      });

    case types.CONTENT_SERIE:
      return Object.assign({}, state, {
        serie: Object.assign({}, state.serie, action.payload),
      });

    case types.CONTENT_SERIE_DRAFT:
      return Object.assign({}, state, {
        serieDraft: Object.assign({}, state.serieDraft, action.payload),
      });

    case types.CONTENT_SERIE_RESET:
      return Object.assign({}, state, {
        serie: {
          videos: [],
        },
      });
    case types.CONTENT_SERIE_DRAFT_RESET:
      return Object.assign({}, state, {
        serieDraft: {
          videos: [],
        },
      });
    case types.CONTENT_CHECK_MEDIA:
      return Object.assign({}, state, {
        exists: Object.assign({}, state.exists, action.payload),
      });

    case types.CONTENT_CHECK_MEDIA_PENDING:
      return Object.assign({}, state, {
        checkMediaPosting: true,
      });
    case types.CONTENT_CHECK_MEDIA_FULFILLED:
      return Object.assign({}, state, {
        checkMediaPosting: false,
        exists: action.payload,
      });
    case types.CONTENT_CHECK_MEDIA_REJECTED:
      return Object.assign({}, state, {
        checkMediaPosting: false,
        checkMediaError: action.payload.response,
      });

    case types.CHANGE_COMMUNITY_FILTER_CONTENT:
      return Object.assign({}, state, {
        filter: action.payload,
      });

    case types.SET_CURRENT_CONTENT:
      return {
        ...state,
        currentContentLanding: action.payload,
      };

    case types.REMOVE_CURRENT_CONTENT:
      return {
        ...state,
        currentContentLanding: null,
      };
    case types.SET_CURRENT_SERIE:
      return {
        ...state,
        currentSerieLanding: action.payload,
      };

    case types.REMOVE_CURRENT_SERIE:
      return {
        ...state,
        currentSerieLanding: null,
      };

    case types.SET_CONTENT_WEBLINK:
      return {
        ...state,
        weblinkURL: action.payload,
      };
    case types.REMOVE_CONTENT_WEBLINK:
      return {
        ...state,
        weblinkURL: "",
      };

    case types.SET_TOP_CONTENT_BY_CATEGORY:
      let type = action.payload.type;
      return {
        ...state,
        topContentByCategory: {
          ...state.topContentByCategory,
          [type]: action.payload.cont,
        },
      };

    case types.SET_CARROUSEL_FOR_LANDING: {
      const { id, type } = action.payload;
      let toSet = null;
      if (state.contentByCategory[type] !== null) {
        toSet = state.contentByCategory[type].find((content) => {
          return content.id === id;
        });
      }

      return {
        ...state,
        currentCarruselLanding: toSet,
      };
    }
    case types.REMOVE_CARROUSEL_FOR_LANDING:
      return {
        ...state,
        currentCarruselLanding: null,
      };
    case types.SET_VIDEO_SUBTITLES:
      return {
        ...state,
        videoSubtitles: action.payload,
      };
    case types.REMOVE_VIDEO_SUBTITLES: 
      return {
        ...state,
        videoSubtitles: [],
      };
    case types.UPLOAD_CONTENT_META:
      return {
        ...state,
        contentToUpload: {
          ...state.contentToUpload,
          metadata: action.payload
        }
      };
    case types.UPLOAD_CONTENT_CATEGORY:
      return {
        ...state,
        contentToUpload: {
          ...state.contentToUpload,
          categoryId: action.payload
        }
      };
    case types.UPLOAD_CONTENT_TAGS:
      return {
        ...state,
        contentToUpload: {
          ...state.contentToUpload,
          tags: action.payload
        }
      }

    case types.UPLOAD_CONTENT_RATING:
      return {
        ...state,
        contentToUpload: {
          ...state.contentToUpload,
          rating: action.payload
        }
      }
    case types.UPLOAD_CONTENT_COVER:
      return {
        ...state,
        contentToUpload_cover: action.payload
      }
    case types.UPLOAD_CONTENT_SUBTITLE:
      return {
        ...state,
        contentToUpload_subtitles: action.payload
      }

    case types.UPLOAD_CONTENT_AUDIO_LANG:
      return {
        ...state,
        contentToUpload: {
          ...state.contentToUpload,
          audioLang: action.payload
        }
      }
    case types.UPLOAD_CONTENT_PRICE:
      return {
        ...state,
        contentToUpload: {
          ...state.contentToUpload,
          authorFee: action.payload
        }
      }
    case types.UPLOAD_CONTENT_DISTRIBUTION:
      return {
        ...state,
        contentToUpload: {
          ...state.contentToUpload,
          seederFee: action.payload
        }
      }
    case types.RESET_UPLOAD_CONTENT:
      return {
        ...state,
        contentToUpload: {
          metadata: [],
          tags: [],
          rating: 1,
          audioLang: "es",
          authorFee: "1.00",
          seederFee: "50",
        },
        contentToUpload_subtitles: [],
        contentToUpload_cover: null
      }
    case types.GET_CONTENT_UPLOAD_UUID:
      return {
        ...state,
        contentUploadUUID: action.payload.uuid
      }
    case types.GET_DRM_TOKEN_PENDING:
      return {
        ...state,
        drmToken: "pending"
        // drmToken: action.payload.token
      }

    case types.GET_DRM_TOKEN_FULFILLED:
      return {
        ...state,
        drmToken: action.payload.token
        // drmToken: action.payload.token
      }

    case types.GET_DRM_TOKEN_REJECTED:
      return {
        ...state,
        drmToken: "rejected"
        // drmToken: action.payload.token
      }
    case types.GET_MANIFEST_PENDING:
      return {
        ...state,
        manifestURL: "pending"
      }
    case types.GET_MANIFEST_FULFILLED:
      return {
        ...state,
        manifestURL: action.payload
      }
    case types.GET_MANIFEST_REJECTED:
      return {
        ...state,
        manifestURL: "rejected"
      }

    case types.SET_CONTENT_TO_EDIT:
      return {
        ...state,
        isEditingContent: true,
        contentToUpload: {
          uuid: action.payload?.uuid,
          metadata: action.payload?.metadata,
          tags: [action.payload?.Tags.map(tag => tag.tag)] || [],
          rating: action.payload?.rating,
          audioLang: action.payload?.audioLang,
          authorFee: action.payload?.authorFee,
          seederFee: action.payload?.seederFee,
          categoryId: action.payload?.category.id,
          contentType: action.payload?.contentType,
          status: action.payload?.status,
          releaseDate: action.payload?.releaseDate,
        },
        contentToUpload_subtitles: action.payload?.subtitle,
        contentToUpload_cover: action.payload?.media[0],
      }

    case types.SET_CONTENT_EDITED:
      return {
        ...state,
        contentToEdit: {
          ...state.contentToEdit,
          metadata: state.contentToUpload.metadata,
          categoryId: state.contentToUpload.categoryId,
          seederFee: state.contentToUpload.seederFee,
          authorFee: state.contentToUpload.authorFee,
          audioLang: state.contentToUpload.audioLang,
          releaseDate: "",
          finishDate: "",
          contentType: state.contentToUpload.contentType,
          rating: state.contentToUpload.rating,
          tags: state.contentToUpload.tags,
          newMediaIds: [],
          deleteMediaIds: [],
          newSubtitleIds: [],
          deleteSubtitleIds: []
        }
      }
    case types.DELETE_MEDIA_ID:
      return {
        ...state,
        contentToEdit: {
          ...state.contentToEdit,
          deleteMediaIds: [...action.payload],
        }
      }
    case types.DELETE_SUBTITLE_ID:
      return {
        ...state,
        contentToEdit: {
          ...state.contentToEdit,
          deleteSubtitleIds: [...action.payload],
        }
      }

    case types.SET_CURRENT_STEP:
      return {
        ...state,
        contentToUploadCurrentStep: action.payload
      }

    case types.SET_CONTENT_TO_SHOW:
      return {
        ...state,
        contentToShow: action.payload
      }
    default:
      return state;
  }
}
